@if (chartOptions && !loading) {
<div
	class="apx-graph"
>
	<div id="chart">
		<apx-chart
			[series]="chartOptions.series"
			[chart]="chartOptions.chart"
			[xaxis]="chartOptions.xaxis"
			[stroke]="chartOptions.stroke"
			[colors]="chartOptions.colors"
			[dataLabels]="chartOptions.dataLabels"
			[plotOptions]="chartOptions.plotOptions"
			[legend]="chartOptions.legend"
			[fill]="chartOptions.fill"
			[markers]="chartOptions.markers"
			[grid]="chartOptions.grid"
			[yaxis]="chartOptions.yaxis"
			[title]="chartOptions.title"></apx-chart>
	</div>
</div>
}
